/* Saloot Designsystem — minimales JS.
   Alles hier ist Zugabe: ohne JS bleibt die Seite vollständig sichtbar
   und bedienbar. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Erst jetzt die Reveal-Startzustände aktivieren — sonst wäre der Inhalt
     bei deaktiviertem JS dauerhaft unsichtbar. */
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('sl-js');
  }

  function observe(scope) {
    if (!root.classList.contains('sl-js')) return;

    var targets = (scope || document).querySelectorAll('.sl-reveal:not(.is-in)');
    if (!targets.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el, i) {
      /* Gestaffelt, aber gedeckelt: eine Reihe soll nicht nacheinander
         durchlaufen wie eine Diashow. */
      var delay = Math.min(i % 4, 3) * 70;
      el.style.transitionDelay = delay + 'ms';
      io.observe(el);
    });
  }

  /* Laufband anhalten, solange es außerhalb des Sichtfelds ist —
     spart Akku auf Mobilgeräten. */
  function idleMarquees() {
    if (!('IntersectionObserver' in window)) return;

    var tracks = document.querySelectorAll('.sl-marquee__track');
    if (!tracks.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.style.animationPlayState = entry.isIntersecting
          ? 'running'
          : 'paused';
      });
    });

    tracks.forEach(function (t) {
      io.observe(t);
    });
  }

  function init(scope) {
    observe(scope);
    idleMarquees();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Im Theme-Editor werden Sections einzeln neu geladen. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();

/* ==========================================================================
   Warenkorb — Schublade und Seite

   Loest Minimogs cart.min.js fuer unsere eigenen Bausteine ab. Zustaendig
   fuer: oeffnen/schliessen, Menge aendern, Zeile entfernen, Anmerkung
   speichern und das Nachladen der beiden Sections danach.

   Ohne JavaScript bleibt alles bedienbar: die Warenkorbseite ist ein
   echtes Formular mit "Mengen aktualisieren", und der Warenkorbknopf im
   Kopf ist ein normaler Link auf /cart.
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER_SECTION = 'sl-cart-drawer';
  var OPEN_CLASS = 'sl-cart-open';

  var root = document.documentElement;
  var lastFocus = null;

  root.classList.add('sl-cart-js');

  function drawer() {
    return document.querySelector('[data-sl-cart-drawer]');
  }

  function cartPage() {
    return document.querySelector('[data-sl-cart-page]');
  }

  /* Welche Sections nach einer Aenderung frisch gebraucht werden. Auf der
     Warenkorbseite gibt es keine Schublade (layout/theme.liquid laesst sie
     dort weg), dafuer die Seite selbst. */
  function sectionIds() {
    var ids = [];
    if (drawer()) ids.push(DRAWER_SECTION);
    var page = cartPage();
    if (page && page.dataset.slCartPage) ids.push(page.dataset.slCartPage);
    return ids;
  }

  /* Die Antwort der Section Rendering API enthaelt je nach Aufrufweg mal
     den Section-Wrapper und mal nur den Inhalt. Deshalb wird nicht auf
     eine Struktur vertraut, sondern im gelieferten HTML nach demselben
     Kennzeichen gesucht, das auch im Dokument steht. */
  function swap(html, selector) {
    var current = document.querySelector(selector);
    if (!current || !html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!fresh) return;
    current.replaceWith(fresh);
  }

  function applySections(sections) {
    if (!sections) return;
    if (sections[DRAWER_SECTION]) swap(sections[DRAWER_SECTION], '[data-sl-cart-drawer]');

    var page = cartPage();
    var pageId = page && page.dataset.slCartPage;
    if (pageId && sections[pageId]) swap(sections[pageId], '[data-sl-cart-page]');
  }

  /* Die Zahl am Warenkorbsymbol im Kopf gehoert Minimogs Header. Sie kommt
     aus /cart.js statt aus der Antwort der Mutation, weil /cart/add.js nur
     die hinzugefuegten Positionen zurueckgibt, nicht den ganzen Korb. */
  function syncCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        return cart;
      })
      .catch(function () {});
  }

  function open() {
    if (!drawer()) {
      window.location.href = window.Shopify.routes.root + 'cart';
      return;
    }
    lastFocus = document.activeElement;
    root.classList.add(OPEN_CLASS);
    var x = document.querySelector('[data-sl-cart-drawer] .sl-cart-drawer__x');
    if (x) x.focus();
  }

  function close() {
    if (!root.classList.contains(OPEN_CLASS)) return;
    root.classList.remove(OPEN_CLASS);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  /* Holt beide Sections frisch, wenn eine Aenderung sie nicht ohnehin
     mitgeliefert hat. */
  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return syncCount();
    /* Bewusst der aktuelle Pfad und nicht die Wurzel: die Section
       Rendering API rendert im Kontext der angegebenen Seite, und die
       Warenkorb-Section gibt es nur unter /cart. */
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(applySections)
      .then(syncCount)
      .catch(function () {});
  }

  function mutate(url, body, line) {
    if (line) line.classList.add('is-busy');
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    return fetch(window.Shopify.routes.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applySections(data.sections);
        syncCount();
        return data;
      })
      .catch(function () {
        /* Wenn der Austausch scheitert, lieber einmal komplett neu laden
           als eine Anzeige, die nicht mehr zum Warenkorb passt. */
        if (line) line.classList.remove('is-busy');
        return refresh();
      });
  }

  function setQuantity(line, quantity) {
    if (!line) return;
    mutate('cart/change.js', { id: line.dataset.slKey, quantity: quantity }, line);
  }

  /* --- Bedienung. Alles delegiert, damit nachgeladenes Markup ohne
         erneute Verdrahtung funktioniert. ------------------------------- */

  document.addEventListener('click', function (ev) {
    /* Warenkorbsymbol im Kopf: Minimogs Link auf /cart faengt die
       Schublade ab. Modifiziertes Klicken (neuer Tab) bleibt ein Link. */
    var icon = ev.target.closest && ev.target.closest('.m-cart-icon-bubble, [data-sl-cart-open]');
    if (icon && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey && ev.button === 0) {
      if (drawer()) {
        ev.preventDefault();
        open();
        return;
      }
    }

    var closer = ev.target.closest && ev.target.closest('[data-sl-cart-close]');
    if (closer) {
      /* Der Knopf im leeren Zustand ist ein Link — der darf navigieren. */
      if (closer.tagName !== 'A') ev.preventDefault();
      close();
      return;
    }

    var step = ev.target.closest && ev.target.closest('[data-sl-qty-step]');
    if (step) {
      ev.preventDefault();
      var stepLine = step.closest('[data-sl-line]');
      var input = stepLine && stepLine.querySelector('[data-sl-qty-input]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 0) + parseInt(step.dataset.slQtyStep, 10);
      if (next < 0) next = 0;
      input.value = next;
      setQuantity(stepLine, next);
      return;
    }

    /* Kabelvorschlag. mutate() liefert die Sections gleich mit zurueck,
       der Block verschwindet dadurch von selbst, sobald das Kabel im Korb
       liegt — die Liquid-Bedingung oben entscheidet das beim Rendern. */
    var upsell = ev.target.closest && ev.target.closest('[data-sl-upsell-add]');
    if (upsell) {
      ev.preventDefault();
      if (upsell.disabled) return;
      var block = upsell.closest('[data-sl-upsell]');
      var sel = block && block.querySelector('[data-sl-upsell-select]');
      var vid = sel ? sel.value : upsell.dataset.slVariant;
      if (!vid) return;
      upsell.disabled = true;
      upsell.textContent = 'Moment …';
      mutate('cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] }).then(function () {
        /* Wenn der Block noch steht, ist etwas schiefgegangen — Knopf
           zurueck in den bedienbaren Zustand statt stumm haengen zu
           lassen. */
        var nochDa = document.querySelector('[data-sl-upsell-add]');
        if (nochDa && nochDa.disabled) {
          nochDa.disabled = false;
          nochDa.textContent = 'Hinzufügen';
        }
      });
      return;
    }

    var remove = ev.target.closest && ev.target.closest('[data-sl-remove]');
    if (remove) {
      ev.preventDefault();
      setQuantity(remove.closest('[data-sl-line]'), 0);
    }
  });

  document.addEventListener('change', function (ev) {
    var input = ev.target.closest && ev.target.closest('[data-sl-qty-input]');
    if (input) {
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      setQuantity(input.closest('[data-sl-line]'), value);
      return;
    }

    var note = ev.target.closest && ev.target.closest('[data-sl-cart-note]');
    if (note) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') close();
  });

  /* Sicherheitsnetz fuer die letzten Minimog-Bausteine (Quick-Add in
     "Zuletzt angesehen", Quick-View): sie melden ihre Aenderung ueber
     Minimogs eigenes Ereignis. Da unsere Schublade ihr <m-cart-drawer>
     ersetzt hat, faengt sie das hier ab. */
  function bridgeMinimog() {
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return false;
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () {
      refresh().then(open);
    });
    return true;
  }

  if (!bridgeMinimog()) {
    /* theme-global.js laeuft mit defer und ist vielleicht noch nicht da. */
    window.addEventListener('load', bridgeMinimog);
  }

  window.SalootCart = {
    open: open,
    close: close,
    refresh: refresh,
    sectionIds: sectionIds,
    applySections: applySections,
    syncCount: syncCount
  };
})();
